import { Link } from 'react-router-dom';

interface ComicCardProps {
  id: number;
  slug: string;
  title: string;
  author: string;
  category: string;
  rating: number;
  cover: string;
  chapters: number;
  views: string;
  isHot?: boolean;
  hideRating?: boolean;
}

export default function ComicCard({
  id,
  slug,
  title,
  author,
  category,
  rating,
  cover,
  chapters,
  views,
  isHot,
  hideRating,
}: ComicCardProps) {
  return (
    <Link
      to={`/comic/${id}`}
      className="group block w-[200px] flex-shrink-0 cursor-pointer"
      data-product-shop=""
    >
      <div className="relative aspect-[3/4] rounded-xl overflow-hidden bg-background-200 mb-3">
        <img
          src={cover}
          alt={title}
          title={`${title} - 免费韩国漫画在线阅读`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        {isHot && (
          <span className="absolute top-2 right-2 bg-primary-500 text-background-50 text-[10px] font-semibold px-2 py-0.5 rounded-full whitespace-nowrap">
            HOT
          </span>
        )}
        {!hideRating && (
          <span className="absolute bottom-2 right-2 bg-background-950/70 backdrop-blur-sm text-background-50 text-xs font-bold px-2 py-0.5 rounded-md whitespace-nowrap">
            {rating}
          </span>
        )}
      </div>
      <h3 className="text-sm font-semibold text-foreground-900 truncate group-hover:text-primary-500 transition-colors">
        {title}
      </h3>
      <div className="flex items-center justify-between mt-1">
        <span className="text-xs text-foreground-500">{category}</span>
        <span className="text-xs text-foreground-400">第{chapters}话</span>
      </div>
      <div className="flex items-center gap-2 mt-0.5">
        <span className="text-[11px] text-foreground-400 truncate">{author}</span>
        <span className="text-[11px] text-foreground-400/60">{views}</span>
      </div>
    </Link>
  );
}